module.exports = __webpack_public_path__ + "img/product_img03.52057a8d.png";